import { usePromo } from '@/context/PromoContext';
import { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const BaseCult = () => {
  const {
    setEnabledQueries,
    cult: {
      selectedCity = null,
      setSelectedCity = () => {},
      queries: { cultSkuDetails = null, querySkuMembership = null } = {},
    } = {},
  } = usePromo() ?? {};

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setEnabledQueries?.({
      cultPromoDetails: true,
      querySkuCount: true,
      querySkuMembership: true,
    });
  }, []);

  useEffect(() => {
    if (cultSkuDetails?.data && selectedCity == null) {
      const city = cultSkuDetails?.data?.pricing?.[0];
      setSelectedCity?.(city);
    }
  }, [cultSkuDetails?.data]);

  useEffect(() => {
    if (
      querySkuMembership?.data?.isMembershipPresent &&
      location.pathname !== '/retail/cult-fit/status'
    ) {
      navigate('/retail/cult-fit/status?status=SUCCESS');
    }
  }, [querySkuMembership?.data, location.pathname, navigate]);

  return <Outlet />;
};

export default BaseCult;
